unit NetNumberGetResponse;
{

/* Initial. */

}
interface

uses
  JS,
  BaseResponse, NetNumberType;

type
  TNetNumberGetResponse = class(TBaseResponse)
  private
    fNetNumber: TNetNumberType;
  public
    property NetNumber: TNetNumberType read fNetNumber;
    constructor Create(const String_JSON: String);
  end;

implementation

constructor TNetNumberGetResponse.Create(const String_JSON: String);
var JSObject_Type: TJSObject;
begin
  JSObject_Type := TJSJSON.parseObject(String_JSON);

  fNetNumber := TNetNumberType.Create(TJSJSON.stringify(JSObject_Type['netNumber']));
end;

end.
